module.exports = __webpack_public_path__ + "img/icon-internet-movil-aqua.2b9ccd72.svg";